export default {

	//
	SET_ACTIVE_DEAL(state, deal) {
		state.deal = deal;
	}

};